import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/consent/legalConsent.module.scss";

const LegalDocumentLink = ({ to, children }) => (
  <Link
    to={to}
    target="_blank"
    rel="noopener noreferrer"
    className={styles.legalLink}
    onClick={(e) => e.stopPropagation()}
  >
    {children}
  </Link>
);

export default LegalDocumentLink;
